// ✅ Library Eksternal
import moment from "moment";
import "moment/locale/id";
import { useEffect, useMemo, useRef, useState } from "react";
import { TablePagination } from "@mui/material";
import { useNavigate } from "react-router-dom";

// ✅ Internal Import
import { ROUTES } from "Route/ConstantRoute";
import { fetchApi } from "Config/fetchApi";
import { DraggableModal } from "Component/Modal/index";
import FilterCustemTable from "Component/CustomTable/filterCustemTable";
import { DetailLogActovity } from "../Detaill";
import { handleError } from "Helper";
import LogCustomTable from "Component/CustomTable/logCustemTable";

const excludeKeys = [
  "password",
  "token",
  "id",
  "uuid",
  "uuid_user",
  "recordId",
  "video_path",
  "image",
  "permission_id",
  "organization_id",
  // "user_password",
];

const menu = [
  { title: "Beranda", titleTable: "-" },
  { title: "Laporan Pemantauan", titleTable: "-" },
  { title: "Organisasi", titleTable: "organization" },
  { title: "Grup Izin Akses", titleTable: "permissiongroup" },
  { title: "Pengaturan Streaming", titleTable: "streamingdevices" },
  { title: "Playback Video", titleTable: "video" },
  { title: "Daftar Pencarian Orang", titleTable: "watchlis" },
  { title: "Daftar Template Wajah", titleTable: "personfaceservice" },
  { title: "Daftar Template Wajah", titleTable: "facerecservice" },
  { title: "Operasi Kepolisian", titleTable: "operation" },
  { title: "Pengguna", titleTable: "auth" },
  { title: "Kamera", titleTable: "iventorycameraservice" },
  { title: "Kendaraan", titleTable: "iventoryservice" },
  { title: "Operasi Kategori", titleTable: "operationkategoriservice" },
  { title: "Log Aktivitas", titleTable: "-" },
  { title: "Lisensi", titleTable: "-" },
];

function getMenuByTitleTable(titleTable) {
  return menu.find((item) => item.titleTable === titleTable);
}
function LogActivity() {
  moment.locale("id");

  // ======== Hook dan Navigasi ======== //
  const navigate = useNavigate();

  // ======== Modal State ======== //
  const [openModal, setOpenModal] = useState(false);

  // ======== Data State ======== //
  const [detailData, setDetailData] = useState({});
  const [data, setData] = useState({});
  console.log(data, "data");
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // ======== Filter & Pagination ======== //
  const [filters, setFilters] = useState([]);
  const [keywordSearch, setDataKeyword] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(5);

  // ======== Header Table & Action Config ======== //
  const [headerTableCustem] = useState([
    { label: "Nama Pengguna", key: "user_name", align: "left" },
    { label: "Nama Menu", key: "title_menu", align: "left" },
    { label: "Aktivitas", key: "action", align: "left" },
    { label: "Waktu", key: "timestamp", align: "center" },
  ]);

  const [isActionTableReport] = useState({
    isAdd: false,
    isEdit: false,
    isShow: true,
    isDelete: false,
  });

  // ======== Filter Config ======== //
  const datafilters = useMemo(
    () => [
      {
        key: "startDate",
        label: "Start Date",
        type: "date",
        isLoading: false,
        options: null,
        multiple: false,
        value: null,
      },
      {
        key: "endDate",
        label: "End Date",
        type: "date",
        isLoading: false,
        options: null,
        multiple: false,
        value: null,
      },
      {
        key: "action",
        label: "Aksi",
        isLoading: false,
        options: [
          { label: "SOFT_DELETE", value: "SOFT_DELETE" },
          { label: "DELETE", value: "DELETE" },
          { label: "CREATE", value: "CREATE" },
          { label: "UPLOAD", value: "UPLOAD" },
          { label: "LOGIN", value: "LOGIN" },
          { label: "START", value: "START" },
          { label: "CHECK", value: "CHECK" },
          { label: "REGISTER", value: "REGISTER" },
          { label: "UPDATE", value: "UPDATE" },
          { label: "STOP", value: "STOP" },
        ],
        multiple: false,
        value: null,
      },
    ],
    []
  );

  // ======== Extract Filter Values ======== //
  const { valueStartDate, valueEndDate, valueAction } = useMemo(() => {
    return {
      valueStartDate: filters[0]?.value ?? null,
      valueEndDate: filters[1]?.value ?? null,
      valueAction: filters[2]?.value?.value ?? "",
    };
  }, [filters]);

  // ======== Parse Data Untuk Tabel ======== //
  const parsedData = useMemo(() => {
    return (
      data?.data?.map((item) => {
        const activity = item.activityData?.[0]?.newValue;
        let timestamp = "";

        if (activity?.description) {
          try {
            const descObj = JSON.parse(activity.description);
            timestamp = descObj.timestamp || "";
          } catch (e) {
            console.error("Gagal parsing description:", e);
          }
        }

        const resultNameMenu = getMenuByTitleTable(item?.table_name);
        return {
          user_name: item.user_name,
          table_name: item?.table_name,
          title_menu:
            item?.table_name === "auth" && item?.action === "LOGIN"
              ? "Login user"
              : resultNameMenu?.title,
          action: item?.action || "",
          timestamp: moment(activity?.date_modified)
            .utcOffset(7)
            .format("D MMMM YYYY [pukul] HH:mm"),
          activityData: item.activityData,
        };
      }) ?? []
    );
  }, [data]);

  // ======== Ambil Data API ======== //
  // const getData = async () => {
  //   try {
  //     setIsLoading(true);

  //     const paramCari = `keyword=${keywordSearch}`;
  //     const paramPage = `page=${pageNumber}`;
  //     const paramSize = `size=${pageSize}`;
  //     const paramAction = `action=${valueAction}`;
  //     const paramStartDate = `startDate=${valueStartDate}`;
  //     const paramEndDate = `endDate=${valueEndDate}`;

  //     // console.log(valueStartDate);

  //     let route;

  //     if (valueAction && valueStartDate && valueEndDate && paramCari) {
  //       route = `/activity-user/get-list-flat?${paramCari}&${paramAction}&${paramStartDate}&${paramEndDate}&${paramPage}&${paramSize}`;
  //     } else if (!valueAction && valueStartDate && valueEndDate && paramCari) {
  //       route = `/activity-user/get-list-flat?${paramCari}&${paramStartDate}&${paramEndDate}&${paramPage}&${paramSize}`;
  //     } else if (valueStartDate && valueEndDate && valueAction) {
  //       route = `/activity-user/get-list-flat?${paramAction}&${paramStartDate}&${paramEndDate}&${paramPage}&${paramSize}`;
  //     } else if (valueStartDate && !valueEndDate && valueAction) {
  //       route = `/activity-user/get-list-flat?${paramAction}&${paramStartDate}&${paramPage}&${paramSize}`;
  //     } else if (valueStartDate && valueEndDate) {
  //       route = `/activity-user/get-list-flat?${paramStartDate}&${paramEndDate}&${paramPage}&${paramSize}`;
  //     } else if (valueStartDate && valueAction) {
  //       route = `/activity-user/get-list-flat?${paramAction}&${paramStartDate}&${paramPage}&${paramSize}`;
  //     } else if (valueEndDate && valueAction) {
  //       route = `/activity-user/get-list-flat?${paramAction}&${paramEndDate}&${paramPage}&${paramSize}`;
  //     } else if (keywordSearch && valueAction) {
  //       route = `/activity-user/get-list-flat?${paramCari}&${paramAction}&${paramPage}&${paramSize}`;
  //     } else if (valueAction) {
  //       route = `/activity-user/get-list-flat?${paramAction}&${paramPage}&${paramSize}`;
  //     } else {
  //       route = `/activity-user/get-list-flat?${paramCari}&${paramPage}&${paramSize}`;
  //     }
  //     const response = await fetchApi().get(route);
  //     setData(response?.data || {});
  //     setError(false);
  //   } catch (err) {
  //     setData([]);
  //     setError(true);
  //     handleError(err);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const getData = async () => {
    try {
      setIsLoading(true);

      const params = new URLSearchParams();

      // Tambahkan parameter hanya jika nilainya ada
      if (keywordSearch) params.append("keyword", keywordSearch);
      if (valueAction) params.append("action", valueAction);
      if (valueStartDate) params.append("startDate", valueStartDate);
      if (valueEndDate) params.append("endDate", valueEndDate);
      if (pageNumber) params.append("page", pageNumber);
      if (pageSize) params.append("size", pageSize);

      const route = `/activity-user/get-list-flat?${params.toString()}`;

      const response = await fetchApi().get(route);
      console.log(response, "response");
      setData(response?.data || {});
      setError(false);
    } catch (err) {
      setData([]);
      setError(true);
      handleError(err);
    } finally {
      setIsLoading(false);
    }
  };
  // ======== Lifecycle Hooks ======== //
  useEffect(() => {
    getData();
  }, [keywordSearch, pageNumber, pageSize, valueAction]);

  useEffect(() => {
    if (datafilters.length > 0) {
      const mapped = datafilters.map((f) => ({
        ...f,
        value: f.multiple ? [] : null,
      }));
      setFilters(mapped);
    }
  }, [datafilters]);

  useEffect(() => {
    if (valueStartDate && valueEndDate) getData();
  }, [valueStartDate, valueEndDate]);

  // ======== Event: Filter Change ======== //
  const handleFilterChange = (key, newValue) => {
    setFilters((prev) =>
      prev.map((f) => (f.key === key ? { ...f, value: newValue } : f))
    );
  };

  // ======== Render UI ======== //
  return (
    <div>
      <div className="text-lg font-bold text-start gap-2 pb-5">
        <p className="text-2xl font-bold" style={{ fontFamily: "Poppins" }}>
          Log Aktivitas
        </p>
      </div>

      <LogCustomTable
        filtersConfig={datafilters}
        filters={filters}
        error={error}
        format={"DD-MM-YYYY"}
        handleFilterChange={handleFilterChange}
        onClickCreate={() => navigate(ROUTES.report.report_create)}
        isAction={isActionTableReport}
        onEditData={(data) =>
          navigate(ROUTES.report.report_update, { state: data })
        }
        onClickShow={(data) => {
          setDetailData(data);
          setOpenModal(true);
        }}
        onDeleteData={(data) => {
          setDetailData(data);
        }}
        isLoading={isLoading}
        headerData={headerTableCustem}
        Data={parsedData}
        onSearchData={setDataKeyword}
        rowsPerPage={pageSize}
        page={pageNumber}
        sxCustem={(f) =>
          f?.key === "tipePerangkat"
            ? 250
            : f?.key === "organisasiPenanggungJawab"
              ? 300
              : f?.key === "operasiKepolisian"
                ? 320
                : 160
        }
        TablePagination={
          <TablePagination
            rowsPerPageOptions={[5, 15, 30, 50]}
            component="div"
            count={data?.totalItems || 0}
            rowsPerPage={pageSize}
            page={pageNumber}
            onPageChange={(e, newPage) => setPageNumber(newPage)}
            onRowsPerPageChange={(e) => {
              setPageSize(e.target.value);
              setPageNumber(0);
            }}
          />
        }
      />

      {/* ======== Modal Detail Data ======== */}
      <DraggableModal size="detail" open={openModal} toggleModal={() => {}}>
        <DraggableModal.Header className="capitalize">
          <div className="flex gap-4 items-center justify-between">
            <p className="text-2xl font-bold" style={{ fontFamily: "Poppins" }}>
              Detail Data
            </p>
            <button
              onClick={() => setOpenModal(false)}
              className="h-10 flex w-auto justify-center items-center rounded-xl hover:bg-neutral-100 px-3 py-1.5 text-xl font-semibold text-black"
            >
              <i className="ri-close-line" />
            </button>
          </div>
        </DraggableModal.Header>
        <DraggableModal.Body>
          <DetailLogActovity data={detailData} excludeKeys={excludeKeys} />
        </DraggableModal.Body>
        <DraggableModal.Footer>
          <div className="flex justify-end gap-4">
            <button
              onClick={() => setOpenModal(false)}
              className="h-11 px-3 py-1.5 rounded-xl bg-btn-login text-white text-sm font-semibold hover:bg-opacity-50"
            >
              Tutup
            </button>
          </div>
        </DraggableModal.Footer>
      </DraggableModal>
    </div>
  );
}

export default LogActivity;
